// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"e75f2c3d","445":"283d95ee","478":"14ea30d2","583":"c6eabb7a","632":"447ff0af","718":"17732216","766":"bee70211"}[chunkId] + ".chunk.js";
};